import axios from "axios";
import { format } from "date-fns";
import React, { Component } from "react";
import MerchantReportsFilter from "../../MerchantReportsFilter";
import MerchantReport from "../../components/merchantReport";
import CategorizationUpload from "./categorizationUpload";
import CategorizationFilter from "./categorizationFilter";
import AxiosClient from "../../../../Network/AxiosClient";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const online_scope_reports = [
  {
    name: "Merchant categorization file by date",
    url: `/api/reports/merchant/categorization-report`,
    filename: "merchant_categorization_file",
    file_type: "zip",
    userTypes: ["bkash-super-user"],
  },
  {
    name: "Merchant categorization file (All merchant)",
    url: `/api/reports/merchant/categorization-report`,
    filename: "merchant_categorization_file_all_merchant",
    file_type: "zip",
    userTypes: ["bkash-super-user"],
    isGeneratable: true,
    requestBody: { reg_start_date: "", reg_end_date: "" },
    statusKey: "merchant-categorization-report_super-admin",
  },
];

const generateStatusObj = (reports) => {
  var obj = {};
  reports.map((i) => {
    if (i.isGeneratable) obj = { ...obj, [i.filename]: { status: "" } };
  });
  return obj;
};

export default class CategorizationReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterOpen: false,
      filter: null,
      fetchingFileName: "",
      user_type: JSON.parse(localStorage.getItem("currUserType")),
      generationStatusConfig: generateStatusObj(online_scope_reports),
    };
  }

  componentDidMount() {
    // online_scope_reports
    //   .filter((report) => report.isGeneratable)
    //   .map((report) => {
    //     this.getReportStatus(report);
    //   });
  }

  filteUserTypePermission = (i) => {
    const user_type = this.state.user_type;
    var filterPass = false;
    if (!i.userTypes) return true;
    if (i.userTypes)
      i.userTypes.map((userType) => {
        if (userType === user_type) filterPass = true;
      });
    return filterPass;
  };

  generatePostBody = (item) => {
    const filter = { ...this.state.filter };
    const status = filter["status"].value;
    const reg_start_date =
      filter["reg_start_date"].value === ""
        ? ""
        : format(new Date(filter["reg_start_date"].value), "yyyy-MM-dd");
    const reg_end_date =
      filter["reg_end_date"].value === ""
        ? ""
        : format(new Date(filter["reg_end_date"].value), "yyyy-MM-dd");

    if (item.filename === "merchant_categorization_file") {
      if (!reg_start_date || !reg_end_date) {
        alert("Please select registration start and end date");
        return null;
      }

      return {
        status,
        reg_start_date,
        reg_end_date,
        region: filter["regions"].value,
        territory: filter["territories"].value,
        area: filter["areas"].value,
        business_unit: filter["business_unit"].value,
        sub_unit: filter["sub_unit"].value,
      };
    }
  };

  callBack = (item) => {
    //console.log(item);
    if (item.isGeneratable) {
      this.generateReportFromRequest(item);
      //his.setState({ filterOpen: true });
    } else this.download(item);
  };

  componentDidUpdate(prevProps, prevState) {
    const item = online_scope_reports[1];
    const statusObj = this.state.generationStatusConfig[item.filename];
    const prevStatusObj = prevState.generationStatusConfig[item.filename];
    if (statusObj.status === "Pending")
      setTimeout(() => {
        this.getReportStatus(item);
      }, 10000);
    else if (
      prevStatusObj.status !== statusObj.status &&
      statusObj.status === "Downloaded"
    )
      this.downloadGeneratableReport(item, statusObj.downloadUrl);
  }

  getReportStatus = async (item) => {
    return AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/reports/v3/get-report-generation-status?report_key=${item.statusKey}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        this.setState((prevState) => ({
          generationStatusConfig: {
            ...prevState.generationStatusConfig,
            [item.filename]: { ...res.data },
          },
        }));

        return { ...res.data };
      })
      .catch((err) => {});
  };

  generateReportFromRequest = async (item) => {
    const statusObj = await this.getReportStatus(item);

    if (statusObj.status === "Not Found") {
      AxiosClient.post(
        `${process.env.REACT_APP_API_URL}${item.url}`,
        { ...item.requestBody },
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
        .then((res) => {
          this.getReportStatus(item);
        })
        .catch((err) => {});
    }
  };

  download = (item) => {
    const body = this.generatePostBody(item);
    console.log(body);
    if (body === null) {
      return;
    }

    this.setState({ fetchingFileName: item.filename });
    axios
      .post(
        `${process.env.REACT_APP_API_URL}${item.url}`,
        {
          ...body,
        },

        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${item.filename}_${format(new Date(), "yyyy-MM-dd")}_${format(
            new Date(),
            "yyyy-MM-dd"
          )}.${item.file_type}`
        );
        document.body.appendChild(link);
        link.click();
      })
      .then(() => this.setState({ fetchingFileName: "" }))
      .catch((err) => {
        this.setState({ fetchingFileName: "" });
        alert(
          "Something went wrong ! Please contact your administrator for details. "
        );
      });
  };

  downloadGeneratableReport = (item, url) => {
    this.setState({ fetchingFileName: item.filename });
    axios
      .get(
        `${url}`,

        {
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `__ALL_${item.filename}.${item.file_type}`
        );
        document.body.appendChild(link);
        link.click();
      })
      .then(() => {
        this.setState({
          fetchingFileName: "",
          generationStatusConfig: generateStatusObj(online_scope_reports),
        });
      })
      .catch((err) => {
        this.setState({ fetchingFileName: "" });
        alert(
          "Something went wrong ! Please contact your administrator for details. "
        );
      });
  };

  render() {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ width: "100%" }}>
          <div className="card-row row categorization-report-container">
            {/* <h4 className="download-header">Download</h4> */}
            <div
              className="card-col col l4 m6 s12"
              style={{
                width: 775,
                background: "#fafafa",
                display: "flex",
                borderRadius: 8,
              }}
            >
              <CategorizationFilter
                callBack={(f) => this.setState({ filter: f })}
              />
              <MerchantReport
                isCompactView={false}
                report={online_scope_reports[0]}
                callBack={() => this.callBack(online_scope_reports[0])}
                fetching={
                  online_scope_reports[0].filename ===
                  this.state.fetchingFileName
                }
                generationStatus={
                  online_scope_reports[0].isGeneratable
                    ? this.state.generationStatusConfig[
                        online_scope_reports[0].filename
                      ]
                    : false
                }
              />
            </div>

            <div
              className="card-col col l4 m6 s12"
              style={{
                width: 420,
                background: "#fafafa",
                marginLeft: 20,
                borderRadius: 8,
                cursor: "no-drop",
              }}
            >
              <MerchantReport
                isCompactView={false}
                report={online_scope_reports[1]}
                callBack={() => this.callBack(online_scope_reports[1])}
                fetching={
                  online_scope_reports[1].filename ===
                  this.state.fetchingFileName
                }
                generationStatus={
                  this.state.generationStatusConfig[
                    online_scope_reports[1].filename
                  ].status
                }
              />
            </div>

            {/* {online_scope_reports
              .filter(this.filteUserTypePermission)
              .map((item, index) => (
                <div
                  key={index}
                  className="card-col col l4 m6 s12"
                  style={{ width: 500 }}
                >
                  <MerchantReport
                    isCompactView={false}
                    report={item}
                    callBack={() => this.callBack(item)}
                    fetching={item.filename === this.state.fetchingFileName}
                    generationStatus={
                      item.isGeneratable
                        ? this.state.generationStatusConfig[item.filename]
                        : false
                    }
                  />
                </div>
              ))} */}
          </div>
          <CategorizationUpload />
        </div>
        {/* <Dialog
          open={this.state.filterOpen}
          onClose={() => this.setState({ filterOpen: false })}
        > */}
        {/* <CategorizationFilter callBack={(f) => this.setState({ filter: f })} /> */}
      </div>
    );
  }
}
